import * as actionConsts from './actions';
import update from 'react/lib/update';

export const initState = {
  projects: [],
  isLoadingProjects: false,
  projectSuggestions: [],
  startDate: null,
  endDate: null
}


export default (state = initState, action) => {
  switch (action.type) {
    case actionConsts.FETCH_SALARY_PROJECTS_REQUEST:
      return update(state, {
        isLoadingProjects: {
          $set: true
        }
      });
    case actionConsts.FETCH_SALARY_PROJECTS_SUCCESS:
      return update(state, {
        isLoadingProjects: {
          $set: false
        },
        projects: {
          $set: action.projects
        }
      });
    case actionConsts.FETCH_SALARY_PROJECTS_FAILURE:
      return update(state, {
        isLoadingProjects: {
          $set: false
        }
      });
    case actionConsts.GET_PROJECT_SUGGESTIONS_SUCCESS:
      return update(state, {
        projectSuggestions: {
          $set: action.suggestions
        }
      });
    case actionConsts.ADD_PROJECT:
      return update(state, {
        projects: {
          $splice: [[0, 0, action.project]]
        },
        projectSuggestions: {
          $set: []
        }
      });
    case actionConsts.REMOVE_PROJECT_FROM_LIST:
      return update(state, {
        projects: {
          $splice: [[action.index, 1]]
        }
      })
    case actionConsts.SET_PROJECT_IS_SELECTED:
      return update(state, {
        projects: {
          [action.projectIndex]: {
            isSelected: {
              $set: action.isSelected
            }
          }
        }
      });
    case actionConsts.SET_SALARY_DATES:
      return update(state, {
        startDate: {
          $set: action.startDate
        },
        endDate: {
          $set: action.endDate
        }
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/Project/Salary/CreateSalary/reducer.js